import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';
import { DateneingabeAnAbreiseDetailWrapper } from './DateneingabeAnAbreiseDetailWrapper';

export interface DateneingabeAnAbreiseProps {
    data: any;
}

export interface DateneingabeAnAbreiseState {
    rowForDialog: any;
    qrUrl?: string;
    hiddenFormFields: Array<any>;
    showSpinner?: boolean;
}

export class DateneingabeAnAbreise extends React.Component<DateneingabeAnAbreiseProps, DateneingabeAnAbreiseState> {

    constructor(props: any) {
        super(props);
        this.state = {
            hiddenFormFields: [],
            rowForDialog: null
        };
        this.onFormChange = this.onFormChange.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {

    }

    onFormChange(WFormData: any): void {
        // const status: number = +WFormData.getValue('status') || null;
        // onFormChangeUniversal(IDs.ENT_FAHRZEUGE, WFormData, this);
        // this.setState({ hiddenFormFields: +status !== 2 ? ['jahr_status'] : [] });
    }

    render(): JSX.Element {
        const customActions = [
            {
                id: 'openAnAbreise',
                label: 'An-/Abreise-Tool öffnen',
                key: 'show',
                func: ((row: any) => this.setState({ rowForDialog: row })),
                info: 'An-/Abreise-Tool öffnen'
            }
        ];
        return (<>
            <WFormsTableWrapper
                entity={IDs.ENT_ANABREISE}
                module={IDs.MOD_ETOOL}
                customClass='Custom-ETA'
                actions={['add', 'edit', 'delete']}
                formLayout='flowV2'
                onDataLoaded={(rows: Array<any>) => {
                    if (this.state.rowForDialog) {
                        const rowLoaded = rows.find((r: any) => r.tid === this.state.rowForDialog.tid);
                        if (rowLoaded) {
                            this.setState({ rowForDialog: rowLoaded });
                        }
                    }
                }}
                customCssStyle={{
                    formcontainer: { marginTop: 'unset', padding: 'unset' }
                }}
                customActions={customActions}
                hiddenFormFields={this.state.hiddenFormFields}
                // customFormConfig={{ standort_tid: { readonly: true } }}
                onFormChange={this.onFormChange}
                callBeforeOnFormSave={(data: any, callback: () => void) => {
                    // console.log('AnAbreise', data);
                    if (!data.kennung) {
                        data.kennung = data.standort_tid + '_' + new Date().getTime();
                    }
                    callback();
                }}
                onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_ANABREISE)}
                globalData={this.props.data}
            />
            {this.state.rowForDialog && this.renderDetailWrapper()}
        </>
        );
    }

    renderDetailWrapper() {
        return <div>
            <DateneingabeAnAbreiseDetailWrapper
                rowTid={(this.state.rowForDialog || {}).tid}
                data={this.props.data}
                useExternOpenButton={true}
                onClose={() => this.setState({ rowForDialog: null })}
            />
        </div>;
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        // return validateFieldUniversal(IDs.ENT_FAHRZEUGE, key, value, data, onValueChange);
        return '';
    }
}
